import {
  Injectable
} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {
  TranslateService,
  LangChangeEvent,
  TranslationChangeEvent,
  DefaultLangChangeEvent,
} from '@ngx-translate/core';

import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {environment} from '@pg-env/environment';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@Injectable()
export class LocalizationService {

  constructor(
    public translate: TranslateService,
  ) {

    translate.setDefaultLang(environment.defaultLanguage);

    translate.use(environment.defaultLanguage);

    translate.onLangChange.subscribe((event: LangChangeEvent) => {
    });

    translate.onTranslationChange.subscribe((event: TranslationChangeEvent) => {
    });

    translate.onDefaultLangChange.subscribe((event: DefaultLangChangeEvent) => {
    });
  }
}
